<style>
    .m-brand .m-brand__logo .m-brand__logo-wrapper {
        display: inline-block;
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
        font-size: 20px;
    }
    #m_header_nav .m-nav__item .btn-group .dropdown-toggle {
        margin-top: 7px;
    }
</style>

<template>
    <header id="m_header" class="m-grid__item m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
        <div class="m-container m-container--fluid m-container--full-height">
            <div class="m-stack m-stack--ver m-stack--desktop">
                <!-- BEGIN: Brand -->
                <div class="m-stack__item m-brand  m-brand--skin-dark ">
                    <div class="m-stack m-stack--ver m-stack--general">
                        <div class="m-stack__item m-stack__item--middle m-brand__logo">
                            <a href="/" class="m-brand__logo-wrapper">{{appName}}
                            </a>
                        </div>
                        <div class="m-stack__item m-stack__item--middle m-brand__tools">
                            <!-- BEGIN: Left Aside Minimize Toggle -->
                            <a href="javascript:;" id="m_aside_left_minimize_toggle" class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
                                <span></span>
                            </a>
                            <!-- END -->
                            <!-- BEGIN: Responsive Aside Left Menu Toggler -->
                            <a href="javascript:;" id="m_aside_left_offcanvas_toggle" class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
                                <span></span>
                            </a>
                            <!-- END -->
                            <!-- BEGIN: Responsive Header Menu Toggler
                            <a id="m_aside_header_menu_mobile_toggle" href="javascript:;" class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
                                <span></span>
                            </a>
                             END -->
                            <!-- BEGIN: Topbar Toggler -->
                            <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;" class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                                <i class="flaticon-more"></i>
                            </a>
                            <!-- BEGIN: Topbar Toggler -->
                        </div>
                    </div>
                </div>
                <!-- END: Brand -->
                <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
                    <!-- BEGIN: Horizontal Menu -->
                    <button class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-dark " id="m_aside_header_menu_mobile_close_btn">
                        <i class="la la-close"></i>
                    </button>
                    <!-- END: Horizontal Menu -->
                    <!-- BEGIN: Topbar -->
                    <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general m-stack--fluid">
                        <div class="m-stack__item m-topbar__nav-wrapper">
                            <ul class="m-topbar__nav m-nav m-nav--inline">
                                <HeaderSearch></HeaderSearch>
                                <!--<HeaderNotifications></HeaderNotifications>
                                <QuickActions></QuickActions>-->
                                <LanguageSwitcher></LanguageSwitcher>
                                <UserProfile></UserProfile>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- END: Topbar -->
            </div>
        </div>
    </header>
</template>

<script>
import HeaderNotifications from './header/HeaderNotifications'
import HeaderSearch from './header/HeaderSearch'
import QuickActions from './header/QuickActions'
import UserProfile from './header/UserProfile'
import LanguageSwitcher from './header/LanguageSwitcher'
export default {
  name: 'Header',
  components: {LanguageSwitcher, UserProfile, QuickActions, HeaderSearch, HeaderNotifications},
  data () {
    return {
      appName: process.env.APP_NAME,
      logoSrc: 'https://assets.creativeagent.hu/dist/default/assets/demo/default/media/img/logo/logo_default_dark.png'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Header.vue